module.exports = __webpack_public_path__ + "static/img/fingerpost_goods_1.f2b8d5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_goods_1.jpg
// module id = nHS9
// module chunks = 0